import {
  Classic,
  HippieChic,
  Large,
  Medium,
  OnePiece,
  Oval,
  Sizes,
  Small,
  Styles,
  Twin,
} from "@components/Icons"
import React, { ButtonHTMLAttributes } from "react"
import * as S from "../elements"

const images = {
  ceramic: require("./ceramic.png"),
  diamonds: require("./diamonds.png"),
  rosegold: require("./rosegold.png"),
  whitegold: require("./whitegold.png"),
  yellowgold: require("./yellowgold.png"),
}

const icons = {
  classic: <Classic />,
  onepiece: <OnePiece />,
  oval: <Oval />,
  hippiechic: <HippieChic />,
  twin: <Twin />,
  small: <Small />,
  medium: <Medium />,
  large: <Large />,
  allSizes: <Sizes />,
  allStyles: <Styles />,
}

export type FilterIcons = keyof typeof icons

export const Line = S.Line

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  status?: "active" | "idle" | "disabled"
  icon?: FilterIcons | string
}

export const Filter: React.FC<Props> = ({
  children,
  status = "idle",
  icon,
  ...rest
}) => {
  return (
    <S.FilterContainer>
      <S.FilterCircle data-status={status} {...rest}>
        {icon && images[icon] && <img src={images[icon]} alt="" />}
        {icon && icons[icon] && icons[icon]}
      </S.FilterCircle>
      <S.LabelEl>{children}</S.LabelEl>
    </S.FilterContainer>
  )
}
